import { render, staticRenderFns } from "./LayerForm.vue?vue&type=template&id=0f20a186"
import script from "./LayerForm.vue?vue&type=script&lang=js"
export * from "./LayerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports